import { put, select, takeEvery, takeLatest } from "redux-saga/effects";

import Organization from "@mapmycustomers/shared/types/Organization";
import User from "@mapmycustomers/shared/types/User";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import i18nService from "@app/config/I18nService";
import PermissionsReportRow from "@app/scene/reports/components/PermissionsReport/types/PermissionsReportRow";
import buildPermissionsReportCsv from "@app/scene/reports/components/PermissionsReport/utils/buildPermissionsReportCsv";
import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { doesOrganizationSupportMileageTracking, getOrganizationId } from "@app/store/iam";
import downloadCsv from "@app/util/file/downloadCsv";

import { downloadPermissionsReportCsv, initializePermissionsReport } from "./actions";
import { getPermissionsReportRows } from "./selectors";

const CSV_FILE_NAME = "MobileDevicePermissions";

function* onInitialize() {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: ListResponse<User> = yield callApi("fetchUsersWithDevicePermissions", orgId);
    yield put(initializePermissionsReport.success(response.data));
  } catch (error) {
    yield put(initializePermissionsReport.failure(error));
    yield put(handleError({ error }));
  }
}

// Role scoping and every filter are applied client-side to the stored users, so the export is a
// projection of what is on screen rather than another round trip.
function* onDownloadCsv() {
  const intl = i18nService.getIntl();
  if (!intl) {
    return;
  }

  const rows: PermissionsReportRow[] = yield select(getPermissionsReportRows);
  const supportsMileageTracking: boolean = yield select(doesOrganizationSupportMileageTracking);
  downloadCsv(CSV_FILE_NAME, buildPermissionsReportCsv(intl, rows, supportsMileageTracking));
}

export function* permissionsReportSagas() {
  yield takeLatest(initializePermissionsReport.request, onInitialize);
  yield takeEvery(downloadPermissionsReportCsv, onDownloadCsv);
}
